import Call from '@commons/call'

const PatientCallPage = () => {
  return <Call />
}

export default PatientCallPage
